import app from '../../../uScope/js/public-api';
import { createButton } from './toolbar-button/toolbar-button';

app.plugins.register({
  name: 'us:resize-viewer',

  extends: 'uScope',

  canStart: function (uScope) {
    return uScope.toolbarCanAddButton('resizeBtn');
  },

  constructor (uScope) {
    createButton(uScope, resizeViewer);
  }
});

function resizeViewer () {
  app.events.trigger('us:resize-viewer:popup-header');
}



// WEBPACK FOOTER //
// ./src/vil/uScope-extensions/resize-viewer/index.js